// extracted by mini-css-extract-plugin
export default {"moreButton":"expanded_filter_wrapper-module___moreButton___a89ad59f"};